
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#338AF3","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#56AF35","d":"M0 0h512v170.7H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M0 341.3l512-170.7L0 0v341.3z"}}),_c('g',{attrs:{"fill":"#ffc945"}},[_c('path',{attrs:{"d":"M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"}}),_c('circle',{attrs:{"cx":"119.5","cy":"148.3","r":"17.5"}}),_c('circle',{attrs:{"cx":"148.9","cy":"158.5","r":"17.5"}}),_c('circle',{attrs:{"cx":"134.7","cy":"135.2","r":"17.5"}}),_c('circle',{attrs:{"cx":"119.5","cy":"172.7","r":"17.5"}}),_c('circle',{attrs:{"cx":"149.9","cy":"182.8","r":"17.5"}}),_c('circle',{attrs:{"cx":"122.5","cy":"198","r":"17.5"}}),_c('circle',{attrs:{"cx":"145.9","cy":"205.2","r":"17.5"}})])])
          )
        }
      }
    